<template>
  <v-list-item>
    <div v-if="!hideImage" class="v-list-item-icon d-flex align-center justify-center ma-0 mr-2">
      <MachineModelImage :size="128"
        :relativePath="item && (item.ModelImage || item.MachineModel && item.MachineModel.ModelImage)">
      </MachineModelImage>
    </div>
    <div class="v-list-item-content py-1">
      <v-list-item-title>
        {{ machineGeneralizerText(item) }}
      </v-list-item-title>
      <v-list-item-title class="primary--text">
        {{ machineIdentifierText(item) }}
      </v-list-item-title>
    </div>
  </v-list-item>
</template>


<script>
import MachineModelImage from "@/components/Cards/MachineModelImage.vue";

export default {
  name: "PreviewMachineListItem",
  props: {
    item: Object,
    hideImage: Boolean,
    showAlerts: Boolean,
    showOpenBtn: Boolean,
  },
  components: {
    MachineModelImage,
  },

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    openMachine(machine) {
      this.$router.push({ name: 'ViewMachine', params: { id: machine.Id } });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>